module.exports = __webpack_public_path__ + "img/couples-063.39f66b76.jpg";